import React from "react";
import { styled, } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import MainListItems from "../../ListItems/ListItems";

const drawerWidth: number = 220;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    backgroundColor: '#FFFFFF',
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      backgroundColor: '#FFFFFF',
      backgroundImage: 'none',
      borderRight: '1px solid #E2E8F0',
      // Keep the 1px border outside the content box so AppBar marginLeft
      // lines up with this edge instead of sitting 1px past it.
      boxSizing: 'content-box',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

interface ISidebarProps {
  open: boolean;
  isAdmin: boolean;
  setOpen: (open: boolean) => void;
}

export const Sidebar:React.FunctionComponent<ISidebarProps> = ({
  open,
  isAdmin,
  setOpen
}) => {

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return <Drawer variant="permanent" open={open}>
    <Toolbar
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        px: [1],
        height: 64,
        minHeight: '64px !important',
        boxSizing: 'border-box',
        bgcolor: '#FFFFFF',
        borderBottom: '1px solid #E2E8F0',
      }}
    >
      <IconButton onClick={toggleDrawer} sx={{ color: '#475569', '&:hover': { bgcolor: '#F1F5F9' } }}>
        <ChevronLeftIcon
          sx={{
            transition: 'transform .2s ease',
            transform: open ? 'none' : 'rotate(180deg)',
          }}
        />
      </IconButton>
    </Toolbar>
    <List component="nav" sx={{ pt: 1, pb: 2, bgcolor: '#FFFFFF' }}>
      <MainListItems isAdmin={isAdmin} open={open} />
    </List>
  </Drawer>
}

export default Sidebar;
